import { Dialog, Modal } from "@mui/material";
import SignUp from "./SignUp";
import FindId from "./FindId";
import AnnouncementList from "./AnnouncementList";

const AnnouncementListModal: React.FC<{
  open: boolean;
  onClose: () => void;
}> = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth // 너비를 100%로 설정
      maxWidth="lg" // 최대 너비를 설정 (필요에 따라 조정)
      sx={{ maxWidth: "900px", width: "100%", margin: "0 auto" }} // 추가적인 스타일
    >
      <AnnouncementList onClose={onClose} />
    </Dialog>
  );
};

export default AnnouncementListModal;
